module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"DENETİM","openedCount":"Açık Madde","totalCount":"Toplam Madde","lastUpdatingTime":"Son Güncelleme Tarihi","twoYearFilter":{"line1":"Son 2 yılda iç denetim","line2":"yapılmamış şubeler"}},"en":{"title":"AUDITS","openedCount":"Open Items","totalCount":"Total Items","lastUpdatingTime":"Last Update","twoYearFilter":{"line1":"Sites don\u0027t have internal","line2":"audits for two years"}}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Audit/AuditRecords/Summary.vue
// module id = vQ/P
// module chunks = 1